import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/wp__logo.png'


const _withScopeId = n => (_pushScopeId("data-v-1153fbc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popupWrapper" }
const _hoisted_2 = { class: "popup" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.017 4.98305C15.4021 5.36817 15.4021 5.99259 15.017 6.37772L11.3947 10L15.017 13.6223C15.4021 14.0074 15.4021 14.6318 15.017 15.017C14.6318 15.4021 14.0074 15.4021 13.6223 15.017L10 11.3947L6.37772 15.0169C5.9926 15.4021 5.36818 15.4021 4.98306 15.0169C4.59793 14.6318 4.59793 14.0074 4.98305 13.6223L8.60533 10L4.98305 6.37772C4.59793 5.9926 4.59793 5.36818 4.98305 4.98306C5.36818 4.59793 5.9926 4.59793 6.37772 4.98305L10 8.60533L13.6223 4.98305C14.0074 4.59792 14.6318 4.59792 15.017 4.98305Z",
    class: "close__btn"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_4),
      _hoisted_5,
      _createElementVNode("h2", {
        innerHTML: _ctx.t('popup.about.title')
      }, null, 8, _hoisted_6),
      _createElementVNode("p", {
        innerHTML: _ctx.t('popup.about.description')
      }, null, 8, _hoisted_7),
      _createElementVNode("p", null, "Web Paint " + _toDisplayString(_ctx.version), 1)
    ], 512), [
      [_directive_click_outside, () => _ctx.$emit('close')]
    ])
  ]))
}